import React from "react"
import {
  BaseEdge,
  EdgeLabelRenderer,
  EdgeProps,
  getSmoothStepPath
} from "@xyflow/react"

import { BranchLabel } from "./AddNodeEdge.styled"

export type ExecutionEdgeData = {
  branchLabel?: "yes" | "no"
}

/**
 * Read-only edge for the execution view — shows the YES/NO branch pill
 * near the source handle but omits the "+" add button.
 */
const ExecutionEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  markerEnd,
  style,
  data
}: EdgeProps) => {
  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    borderRadius: 8
  })

  const edgeData = data as ExecutionEdgeData | undefined

  return (
    <>
      <BaseEdge id={id} path={edgePath} markerEnd={markerEnd} style={style} />
      {edgeData?.branchLabel && (
        <EdgeLabelRenderer>
          <BranchLabel
            $variant={edgeData.branchLabel}
            style={{
              transform: `translate(-50%, -50%) translate(${sourceX}px, ${sourceY + 16}px)`
            }}
            className="nodrag nopan"
          >
            {edgeData.branchLabel === "yes" ? "Yes" : "No"}
          </BranchLabel>
        </EdgeLabelRenderer>
      )}
    </>
  )
}

export default ExecutionEdge
